import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../api/endpoints';
import type { PendingNotice } from '../api/types';
import { meQueryKey } from '../app/queryClient';
import { Modal } from '../components/Modal';
import { MutationError } from '../components/MutationError';
import { renderText } from '../documents/render';
import { useAuth } from './context';

// NoticeGate: Hinweis, den jeder Benutzer vor der Arbeit mit „OK“ bestätigen muss (erster Login bzw. nach jeder
// Änderung des Textes). Ohne Bestätigung bleibt nur Abmelden.
export function NoticeGate({ notice }: { notice: PendingNotice }) {
  const { logout } = useAuth();
  const queryClient = useQueryClient();
  const ack = useMutation({
    mutationFn: () => api.acknowledgeNotice(notice.key, notice.version),
    onSettled: () => queryClient.invalidateQueries({ queryKey: meQueryKey }),
  });
  return (
    <Modal
      title={notice.title}
      size="wide"
      dismissible={false}
      actions={
        <>
          <button type="button" className="btn" onClick={() => void logout()}>
            Abmelden
          </button>
          <button type="button" className="btn btn-primary" disabled={ack.isPending} onClick={() => ack.mutate()} data-autofocus>
            OK
          </button>
        </>
      }
    >
      <div className="notice-text">{renderText(notice.body)}</div>
      {ack.isError && <MutationError error={ack.error} />}
    </Modal>
  );
}
